import { isUndefined } from 'lodash/fp';
import { useQuery } from '@apollo/client/react';

import { GET_PERK_DETAIL } from '../../shared/get-perk/query.gql';
import { GET_PERK_IDS } from './query.gql';
import getSanityDocumentBySlug from '../../../../../cms/utils/get-sanity-document-by-slug';

const useGetPerk = (slug: string) => {
  const { data: idRequestData, error: idRequestError, loading: idRequestLoading } = useQuery(GET_PERK_IDS);

  const perksWithSlug = idRequestData?.allMemberPerk;

  const { _id: matchedId } = getSanityDocumentBySlug(perksWithSlug, slug);

  const idRequestComplete = !idRequestLoading;

  const {
    data,
    loading: detailRequestLoading,
    error: detailRequestError,
  } = useQuery(GET_PERK_DETAIL, {
    skip: !idRequestComplete || isUndefined(matchedId),
    variables: { id: matchedId ?? '' },
  });

  return {
    error: !!(idRequestError || detailRequestError),
    loading: !idRequestComplete || detailRequestLoading,
    perk: data?.allMemberPerk?.[0],
  };
};

export default useGetPerk;
